import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "openButton"]
  static values = { loadUrl: String }

  connect() {
    this.handleResize = this.syncFrameHeight.bind(this)
    window.addEventListener("resize", this.handleResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
  }

  open() {
    this.element.classList.add("program-current-video__layout--chat-open")
    this.openButtonTarget.classList.add("hidden")
    this.frameTarget.classList.remove("hidden")
    this.syncFrameHeight()

    if (!this.frameTarget.getAttribute("src")) {
      this.frameTarget.setAttribute("src", this.loadUrlValue)
    }
  }

  close() {
    this.element.classList.remove("program-current-video__layout--chat-open")
    this.openButtonTarget.classList.remove("hidden")
    this.frameTarget.classList.add("hidden")
    this.frameTarget.style.height = ""
  }

  syncFrameHeight() {
    if (!this.element.classList.contains("program-current-video__layout--chat-open")) return
    if (window.matchMedia("(max-width: 1280px)").matches) {
      this.frameTarget.style.height = ""
      return
    }

    const player = this.element.querySelector(".program-current-video__player")
    if (!player) return

    this.frameTarget.style.height = `${player.offsetHeight}px`
  }
}
